<template>
	<div>
		<AppHeader title="1:1 문의 상세" is-history />

		<AppContent>
			<InquiryDetail />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';
import InquiryDetail from '@/components/InquiryDetail/InquiryDetail';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		InquiryDetail,
	},
};
</script>
